import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AdminLayout from '../components/AdminLayout';
import { Card } from '../components/ui/card';
import JobLogTimeline from '../components/JobLogTimeline';

const BookingJobLog = () => {
  const { bookingId } = useParams();
  return (
    <AdminLayout title="Job Log" subtitle={`Audit trail for ${bookingId}`}>
      <div className="mb-4">
        <Link to="/admin/bookings" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] text-gray-500 hover:text-black" data-testid="job-log-back">
          <ArrowLeft className="h-3.5 w-3.5" /> Back to bookings
        </Link>
      </div>
      <Card className="p-6 max-w-3xl" data-testid="job-log-card">
        <div className="mb-5">
          <p className="text-[10px] tracking-[0.3em] uppercase font-semibold text-gray-400">Booking</p>
          <h2 className="text-2xl font-bold text-black mt-0.5">{bookingId}</h2>
        </div>
        <JobLogTimeline bookingId={bookingId} />
      </Card>
    </AdminLayout>
  );
};

export default BookingJobLog;
